import React, { Component } from 'react';
import { Input, FormGroup, Label, Button, UncontrolledTooltip, Row, Col } from 'reactstrap';
import { ModelPropertiesParser } from '../commons/modelPropertiesParser';
import config from '../../config';
import client from '../../client';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import { toJS } from '../../containers/to-js';
import { uploadFiles, clearUploader } from '../../actions/uploader';
import { renderErrorMessage } from './_FORM_FIELDS';
import { Field, change, formValueSelector } from 'redux-form/immutable';
import { toast } from 'react-toastify';
import PrintText from './PrintText';
import RenderIcon from '../commons/RenderIcon';

let dropzoneRef;

const MAGIC_NUMBERS = {
    jpg: ['ffd8ff'],
    png: ['89504e47'],
    gif: ['47494638'],
    pdf: ['25504446'],
};

const hexFromBytes = (bytes) => {
    return Array.from(bytes)
        .map(byte => byte.toString(16).padStart(2, '0'))
        .join('');
}

const validateMagicNumber = (file, allowedTypes) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const bytes = new Uint8Array(reader.result).slice(0, 4);
            const hex = hexFromBytes(bytes).toLowerCase();
            const isValid = allowedTypes.some(type =>
                MAGIC_NUMBERS[type] && MAGIC_NUMBERS[type].some(function (sig) {
                    return hex.startsWith(sig);
                })
            );
            resolve(isValid);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file.slice(0, 4));
    });
}

export const requiredFile = value => {
    const files = value && typeof value.toJS === 'function' ? value.toJS() : value;
    const hasFile = Array.isArray(files)
        ? files.some(file => typeof file === 'string' && file.trim() && file !== 'null')
        : typeof files === 'string' && files.trim() && files !== 'null';
    return hasFile ? undefined : 'This field is required';
};

const fileValues = value => {
    const files = value && typeof value.toJS === 'function' ? value.toJS() : value;
    return (Array.isArray(files) ? files : [files])
        .filter(file => typeof file === 'string' && file.trim() && file !== 'null');
};

const fileCountLimit = value => {
    if (value == null || String(value).trim() === '') return null;
    const count = Number(value);
    return Number.isInteger(count) && count >= 0 ? count : null;
};

const fileFieldLabel = (layoutItem, translate) => {
    const { label = {} } = layoutItem.itemProperties;
    let text = label.text || '';
    if (label.languageKey && typeof translate === 'function') {
        try {
            const translated = translate(`label.${label.languageKey.toLowerCase().replace(/ /g, "_")}`);
            if (typeof translated === 'string' && !translated.startsWith('Missing translation')) text = translated;
        } catch (error) {
            // Use the configured label if its translation is unavailable.
        }
    }
    return typeof text === 'string' ? text.trim() : '';
};

export const fileCountError = (count, layoutItem, labelText = fileFieldLabel(layoutItem)) => {
    const { field, fileOptions = {} } = layoutItem.itemProperties;
    if (!field.collection) return undefined;
    const settings = { ...fileOptions, ...layoutItem.config };
    const min = fileCountLimit(settings.minFile);
    const max = fileCountLimit(settings.maxFile);
    const labelSuffix = labelText ? ` in ${labelText}` : '';
    if (min !== null && count < min) {
        return `Please select at least ${min} ${min === 1 ? 'file' : 'files'}${labelSuffix}.`;
    }
    if (max !== null && count > max) {
        return `You can upload a maximum of ${max} ${max === 1 ? 'file' : 'files'}${labelSuffix}.`;
    }
    return undefined;
};

class FileValidationMessage extends Component {
    componentDidMount() {
        this.notify();
    }
    componentDidUpdate(previousProps) {
        this.notify(previousProps);
    }
    notify(previousProps) {
        const { input, meta, fileCountValidator } = this.props;
        const error = fileCountValidator(input.value);
        const valueChanged = previousProps && JSON.stringify(previousProps.input.value) !== JSON.stringify(input.value);
        if (!error || (!meta.touched && !valueChanged)) return;
        if (!previousProps || valueChanged || !previousProps.meta.touched ||
            (!previousProps.meta.submitFailed && meta.submitFailed) ||
            previousProps.fileCountValidator(previousProps.input.value) !== error) {
            toast.error(error, { autoClose: true, position: toast.POSITION.TOP_CENTER });
        }
    }
    render() {
        return renderErrorMessage(this.props);
    }
}

export class Uploader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            classProperty: null,
            removedFiles: [],
            removed: false
        }
        this.uploaderToastId = null;
        this.validateFileCount = value => {
            const { itemProperties } = this.props.layoutItem;
            const count = fileValues(value).length;
            const required = (itemProperties.field.properties && itemProperties.field.properties.required) ||
                parseInt(itemProperties.minLength, 10) > 0;
            if (count === 0 && !required) return undefined;
            return fileCountError(count, this.props.layoutItem, fileFieldLabel(this.props.layoutItem, this.props.translate));
        };
    }
    onDrop(accepted, rejected) {

        let fileSizeNumber = this.props.layoutItem && this.props.layoutItem.config && this.props.layoutItem.config.fileSizeNumber ? this.props.layoutItem.config.fileSizeNumber :
            this.props.layoutItem.itemProperties.fileOptions && this.props.layoutItem.itemProperties.fileOptions.fileSizeNumber ? this.props.layoutItem.itemProperties.fileOptions.fileSizeNumber : this.props.layoutItem.itemProperties.imageConfig && this.props.layoutItem.itemProperties.imageConfig.fileSizeNumber
        let fileSize = this.props.layoutItem && this.props.layoutItem.config && this.props.layoutItem.config.fileSize ? this.props.layoutItem.config.fileSize.value :
            this.props.layoutItem.itemProperties.fileOptions && this.props.layoutItem.itemProperties.fileOptions.fileSize &&
                this.props.layoutItem.itemProperties.fileOptions.fileSize.value ? this.props.layoutItem.itemProperties.fileOptions.fileSize.value :
                this.props.layoutItem.itemProperties.imageConfig && this.props.layoutItem.itemProperties.imageConfig.fileSize ?
                    this.props.layoutItem.itemProperties.imageConfig.fileSize.value : '';
        let fileSizeName = this.props.layoutItem && this.props.layoutItem.config && this.props.layoutItem.config.fileSize ?
            this.props.layoutItem.config.fileSize.name : this.props.layoutItem.itemProperties.fileOptions && this.props.layoutItem.itemProperties.fileOptions.fileSize &&
                this.props.layoutItem.itemProperties.fileOptions.fileSize.name ? this.props.layoutItem.itemProperties.fileOptions.fileSize.name
                : this.props.layoutItem.itemProperties.imageConfig && this.props.layoutItem.itemProperties.imageConfig.fileSize ?
                    this.props.layoutItem.itemProperties.imageConfig.fileSize.name : '';
        fileSizeNumber = fileSizeNumber && parseInt(fileSizeNumber);
        fileSize = fileSize && parseInt(fileSize);
        const fileSizeTotal = fileSize * fileSizeNumber;
        let isValidFile = true;

        if (rejected && rejected.length > 0) {
            this.uploaderToastId = toast.error('Invalid file format...', { autoClose: true, position: toast.POSITION.TOP_CENTER });
        }
        else {
            
            let checkPdf = false;
            const { itemProperties } = this.props.layoutItem;
            const { field } = itemProperties;
            const fileOptions = itemProperties && itemProperties.fileOptions;

            const countError = fileCountError(accepted ? accepted.length : 0, this.props.layoutItem,
                fileFieldLabel(this.props.layoutItem, this.props.translate));
            if (countError) {
                this.uploaderToastId = toast.error(countError, { autoClose: true, position: toast.POSITION.TOP_CENTER });
                return;
            }
            if (!accepted || !accepted.length) return;

            if (fileOptions && fileOptions.fileFormat && fileOptions.fileFormat.value === "file") {
                if (fileOptions.fileFormatSelection) {
                    console.log(fileOptions.fileFormatSelection);
                    if (fileOptions.fileFormatSelection.some(o => {
                        return o.value.includes("pdf");
                    })) {
                        checkPdf = true;
                    }
                }
            }
            if (field.collection) {
                checkPdf = false;
            }
            accepted && accepted.map(async (file, index) => {
                if (file.size > fileSizeTotal) {
                    isValidFile = false;
                    this.uploaderToastId = toast.error(`File size should be less than ${fileSizeNumber} ${fileSizeName}`, { autoClose: true, position: toast.POSITION.TOP_CENTER });
                }
                if (checkPdf) {
                    let isPDF = await validateMagicNumber(file, ['pdf'])
                    if (isPDF) {
                        this.uploaderToastId = toast.info('Upload in progress. Please wait...', { autoClose: false, position: toast.POSITION.TOP_CENTER });
                        const isProtected = this.props.layoutItem.itemProperties && this.props.layoutItem.itemProperties.fileOptions && this.props.layoutItem.itemProperties.fileOptions.isSecure;
                        this.setState({ files: [...accepted], classProperty: this.props.classProperty, removed: false }, () => {
                            this.props.uploadFiles({ files: this.state.files, namespace: this.props.classProperty, isProtected })
                        });
                    } else {
                        this.uploaderToastId = toast.error('Invalid file...', { autoClose: true, position: toast.POSITION.TOP_CENTER });
                    }
                }
            })
            if (isValidFile && !checkPdf) {
                this.uploaderToastId = toast.info('Upload in progress. Please wait...', { autoClose: false, position: toast.POSITION.TOP_CENTER });
                const isProtected = this.props.layoutItem.itemProperties && this.props.layoutItem.itemProperties.fileOptions && this.props.layoutItem.itemProperties.fileOptions.isSecure;
                this.setState({ files: [...accepted], classProperty: this.props.classProperty, removed: false }, () => {
                    this.props.uploadFiles({ files: this.state.files, namespace: this.props.classProperty, isProtected })
                });
            }
        }
    }
    componentWillReceiveProps(nextProps) {
        const { uploader, classProperty, formValues, inlineFormKey, dispatch, companyDetails, fileValue } = nextProps;
        const fileUploadSuccess = companyDetails && companyDetails.data && companyDetails.data.companySettings && companyDetails.data.companySettings.fileUploadSuccess
        const fileError = companyDetails && companyDetails.data && companyDetails.data.companySettings && companyDetails.data.companySettings.fileError

        const { itemProperties } = nextProps.layoutItem;
        const { field } = itemProperties;
        if (uploader && !uploader.hasError && uploader.data && this.state.classProperty === classProperty) {
            const url = field.collection ? uploader.data.data : uploader.data.data[0];
            // let fieldValue = formValues && ModelPropertiesParser(`{{${classProperty}}}`, formValues);
            // fieldValue = fieldValue && typeof fieldValue != 'string' ? fieldValue[0] : fieldValue;
            let applyUploadForCollection = false;
            if (field.collection) {
                if (fileValue) {
                    applyUploadForCollection = !(JSON.stringify(fileValue) == JSON.stringify(url))
                } else if (!fileValue && url) {
                    applyUploadForCollection = true;
                }
            }
            if ((field.collection ? applyUploadForCollection : fileValue != url) && !this.state.removed && !window.saveClicked) {
                this.props.clearUploader(classProperty);
                this.setState({ classProperty: null }, () => {
                    inlineFormKey && inlineFormKey.startsWith('workflow-card') ? dispatch(change('create-update-form-base', classProperty, url)) : nextProps.change(classProperty, url);
                });
                toast.update(this.uploaderToastId, {
                    render: fileUploadSuccess ? fileUploadSuccess : "Upload Done!",
                    type: toast.TYPE.SUCCESS,
                    autoClose: 5000,
                    position: toast.POSITION.TOP_CENTER
                });
            }

        }
        if (uploader && uploader.hasError) {
            toast.update(this.uploaderToastId, {
                render: fileError ? fileError : "Something went wrong. Could not upload file at this time.",
                type: toast.TYPE.ERROR,
                autoClose: 5000,
                position: toast.POSITION.TOP_CENTER
            });
        }
    }
    removeFile(index, classProperty) {
        const { layoutItem: { itemProperties }, fileValue } = this.props;
        let fieldValue = fileValues(fileValue);
        const collection = itemProperties && itemProperties.field && itemProperties.field.collection;
        let files = Object.assign([], this.state.files);
        files.splice(index, 1);
        this.setState({ files, removed: true }, () => {
            if (collection) {
                fieldValue.splice(index, 1);
                this.props.change(classProperty, fieldValue ? fieldValue : [])
            } else {
                this.props.change(classProperty, '')
            }
        });
    }
    removeFileFromForm(name, index) {
        const { layoutItem: { itemProperties }, fileValue } = this.props;
        let fieldValue = fileValues(fileValue);
        const collection = itemProperties && itemProperties.field && itemProperties.field.collection;
        if (collection) {
            fieldValue.splice(index, 1);
            this.props.change(name, fieldValue)
        } else {
            this.props.change(name, '');
            let removedFiles = Object.assign([], this.state.removedFiles);
            const found = removedFiles.find(ele => ele == name)
            !found && removedFiles.push(name);
            this.setState({ removedFiles });
        }
    }
    render() {
        const { itemProperties } = this.props.layoutItem;
        const colConfig = this.props.layoutItem.config;

        const dropboxTemplate = this.props.companyDetails && this.props.companyDetails.data && this.props.companyDetails.data.companySettings && this.props.companyDetails.data.companySettings.dropboxTemplate
        const { uploader, classProperty, isReadOne, customIcons, workflowData, dontShowDROPBOX, translate, itemClassPropertyFromTable, formValues } = this.props;
        const requiresFile = itemProperties.field.properties.required || parseInt(itemProperties.minLength, 10) > 0;
        const validations = [this.validateFileCount].concat(requiresFile ? [requiredFile] : [], this.props.validations || []);
        let updatedClassProperty = this.props.classProperty
        let parentModelField = '';
        let indexChild = '';
        const fieldID = itemProperties && itemProperties.field && itemProperties.field.id;
        if (updatedClassProperty.indexOf('].') !== -1) {

            parentModelField = updatedClassProperty.substring(0, updatedClassProperty.indexOf('['))
            indexChild = updatedClassProperty.substring(updatedClassProperty.indexOf('[') + 1, updatedClassProperty.indexOf(']'))
            indexChild = parseInt(indexChild)
        }
        let workflowDataUpdated = workflowData && parentModelField && workflowData[parentModelField] ? workflowData[parentModelField][indexChild] : workflowData
        let uploadedFileName = classProperty && classProperty.indexOf('{{') == -1 ? ModelPropertiesParser(`{{${classProperty}}}`, workflowData) : ModelPropertiesParser(classProperty, workflowData);
        if (itemClassPropertyFromTable) {
            uploadedFileName = itemClassPropertyFromTable.indexOf('{{') == -1 ? ModelPropertiesParser(`{{${itemClassPropertyFromTable}}}`, workflowDataUpdated) : ModelPropertiesParser(itemClassPropertyFromTable, workflowDataUpdated);
        }
        let fieldValue = formValues && ModelPropertiesParser(`{{${classProperty}}}`, formValues);
        if (fieldValue && typeof fieldValue == 'string') {
            if (fieldValue.includes('[') && fieldValue.includes(']')) {
                fieldValue = JSON.parse(fieldValue)
            }
            uploadedFileName = fieldValue
        }

        let uploadFileNameUrl = '';
        if (uploadedFileName && typeof uploadedFileName == 'string') {
            uploadFileNameUrl = uploadedFileName.startsWith('http') ? uploadedFileName : `${config.assetsBasePath}${uploadedFileName}`
        } else if (uploadedFileName && Array.isArray(uploadedFileName)) {
            let tmp = [];
            for (let name of uploadedFileName) {
                const t = name.startsWith('http') ? name : `${config.assetsBasePath}${name}`;
                tmp.push(t)
            }

            uploadFileNameUrl = tmp.join(' ');
        }


        let result = uploadFileNameUrl.replace(/\/\//g, "/");
        uploadFileNameUrl = result.replace("https:/", "https://");
        if (uploadedFileName && Array.isArray(uploadedFileName)) {
            uploadFileNameUrl = uploadFileNameUrl.split(',')
        }

        const { label, field, placeholder, footer, info } = itemProperties;
        const fileFormat = colConfig && colConfig.fileFormat ? colConfig.fileFormat : itemProperties && itemProperties.imageConfig && itemProperties.imageConfig.fileFormat ? itemProperties.imageConfig.fileFormat : null
        const imageFormatSelection2 = itemProperties && itemProperties.imageConfig && itemProperties.imageConfig.imageFormatSelection ? itemProperties.imageConfig.imageFormatSelection : null
        const onlyIconDropboxImage = itemProperties && itemProperties.imageConfig && itemProperties.imageConfig.onlyIconDropbox ? itemProperties.imageConfig.onlyIconDropbox : null
        const fileFormatUploader = colConfig && colConfig.fileFormat ? colConfig.fileFormat : itemProperties && itemProperties.fileOptions && itemProperties.fileOptions.fileFormat ? itemProperties.fileOptions.fileFormat : null
        const fileboxtemplate = itemProperties && itemProperties.fileOptions && itemProperties.fileOptions.fileboxtemplate ? itemProperties.fileOptions.fileboxtemplate : null
        const fileFormatSelection = itemProperties && itemProperties.fileOptions && itemProperties.fileOptions.fileFormatSelection ? itemProperties.fileOptions.fileFormatSelection : null
        const hideDropBox = itemProperties && itemProperties.fileOptions && itemProperties.fileOptions.hideDropBox ? itemProperties.fileOptions.hideDropBox : null
        const dropboxtext = itemProperties && itemProperties.fileOptions && itemProperties.fileOptions.dropboxtext ? itemProperties.fileOptions.dropboxtext : null
        const hideFileName = itemProperties && itemProperties.fileOptions && itemProperties.fileOptions.hideFileName ? itemProperties.fileOptions.hideFileName : null
        const dropboxtextImage = itemProperties && itemProperties.imageConfig && itemProperties.imageConfig.dropboxtext ? itemProperties.imageConfig.dropboxtext : null
        const hideFileNameImage = itemProperties && itemProperties.imageConfig && itemProperties.imageConfig.hideFileName ? itemProperties.imageConfig.hideFileName : null

        uploadedFileName = hideFileName ? ' ' : hideFileNameImage ? ' ' : uploadedFileName;
        const dropboxMainText = dropboxtext ? dropboxtext : dropboxtextImage ? dropboxtextImage : dropboxTemplate == 'TEMPLATE_TWO' ? 'Drag & Drop files here (upto 10mb)' : 'Drag & Drop files here'

        const fileboxtemplateImage = itemProperties && itemProperties.imageConfig && itemProperties.imageConfig.fileboxtemplate ? itemProperties.imageConfig.fileboxtemplate : null
        const allFormatSelection = colConfig && colConfig.allFormatSelection ? colConfig.allFormatSelection : itemProperties && itemProperties.fileOptions && itemProperties.fileOptions.allFormatSelection ? itemProperties.fileOptions.allFormatSelection : null
        const imageFormatSelection = itemProperties && itemProperties.fileOptions && itemProperties.fileOptions.imageFormatSelection ? itemProperties.fileOptions.imageFormatSelection : null
        const videoFormatSelection = itemProperties && itemProperties.fileOptions && itemProperties.fileOptions.videoFormatSelection ? itemProperties.fileOptions.videoFormatSelection : null
        const audioFormatSelection = itemProperties && itemProperties.fileOptions && itemProperties.fileOptions.audioFormatSelection ? itemProperties.fileOptions.audioFormatSelection : null
        const onlyIconDropboxFile = itemProperties && itemProperties.fileOptions && itemProperties.fileOptions.onlyIconDropbox ? itemProperties.fileOptions.onlyIconDropbox : dontShowDROPBOX ? dontShowDROPBOX : null;
        const onlyIconDropboxVideoFile = itemProperties && itemProperties.videoConfig && itemProperties.videoConfig.onlyIconDropbox ? itemProperties.videoConfig.onlyIconDropbox : null
        const minLength = itemProperties.minLength;
        const { files, removedFiles } = this.state;
        const removedFile = removedFiles.find(ele => ele == classProperty);
        const translatedLabel = fileFieldLabel(this.props.layoutItem, translate);
        if (isReadOne) {
            return <PrintText {...this.props} />
        }
        const classNameCustom = dropboxTemplate == 'TEMPLATE_TWO' ? 'player-dropzone-uploader-wrapper-template-2' : 'player-dropzone-uploader-wrapper'
        const classNameCustomField = dropboxTemplate == 'TEMPLATE_TWO' ? 'player-dropzone-uploader-template-2' : 'player-dropzone-uploader'
        if (hideDropBox) {
            return (
                <FormGroup className={classNameCustom}>
                    {
                        label.show ? <Label>{translatedLabel}{field.properties.required || minLength ? <sup>*</sup> : ''}</Label> : ''
                    }
                    <Field
                        name={classProperty}
                        component={FileValidationMessage}
                        fileCountValidator={this.validateFileCount}
                        validate={validations}
                    />
                </FormGroup>
            )
        }
        if ((fileFormat && fileFormat.value === 'image') || (fileFormatUploader && fileFormatUploader.value === 'image')) {
            let acceptImage = []
            {
                imageFormatSelection && imageFormatSelection.map((imageFormat, index) => {
                    acceptImage.push(imageFormat.value)
                })
            }
            {
                imageFormatSelection2 && imageFormatSelection2.map((imageFormat, index) => {
                    acceptImage.push(imageFormat.value)
                })
            }
            const acceptOnly = acceptImage.length > 0 ? acceptImage.join(',') : "image/png, image/gif, image/jpeg, image/svg+xml,image/tiff,image/x-icon"
            return (
                <FormGroup className={classNameCustom}>
                    {
                        label.show ? <Label>{translatedLabel}{field.properties.required || minLength ? <sup>*</sup> : ''}</Label> : ''
                    }
                    <Field
                        name={classProperty}
                        component={FileValidationMessage}
                        fileCountValidator={this.validateFileCount}
                        validate={validations}
                    />

                    <Dropzone multiple={field.collection} className={classNameCustomField} accept={acceptOnly} ref={(node) => { dropzoneRef = node; }} onDrop={this.onDrop.bind(this)}>
                        <div className='d-flex flex-column pt-2 pb-2 dropboxDiv'>
                            <p className='text-center'><i className="fa fa-3x fa-cloud-upload text-info" aria-hidden="true"></i></p>
                            <p className='text-center mb-1 mt-0'>Drag &amp; Drop Image files here</p>
                            <p className='text-center mb-1 mt-0'>or</p>
                            <p className='text-center mb-0'>
                                <Button onClick={(ev) => { ev.preventDefault() }} color='success' outline>Choose File</Button>
                            </p>
                        </div>
                    </Dropzone>

                    <FilesList files={files} removeFile={this.removeFile.bind(this)} {...this.props} />
                    {!(files.length > 0) && uploadedFileName && !(uploadedFileName === "null") && !removedFile &&
                        <ViewFileOption
                            uploadedFileName={uploadedFileName}
                            uploadFileNameUrl={uploadFileNameUrl}
                            classProperty={classProperty}
                            removeFileFromForm={this.removeFileFromForm.bind(this)}
                        />
                        // <div>
                        //     {
                        //         uploadedFileName.startsWith('protected/') ? <a href={""} onClick={(e) => {
                        //             e.preventDefault();
                        //             client().get(`${config.playerApi}/${`uploadedFileName`}`).then(res => {
                        //                 window.open(res.data);
                        //             }).catch(e => {
                        //                 console.log(e)
                        //             })

                        //         }}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download (${uploadedFileName})`}</a> : <a target="_blank" href={uploadFileNameUrl}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download (${uploadedFileName})`}</a>
                        //     }
                        //     <Button onClick={this.removeFileFromForm.bind(this, classProperty)} color='link' className='p-0 ml-1' title='Remove this file'>
                        //         <i className="fa fa-times text-danger" aria-hidden="true"></i>
                        //     </Button></div>
                    }
                    {
                        footer && footer.show ? <h6 width='100%' className="footer-text">{footer.text}</h6> : ''
                    }
                </FormGroup>
            );

        }
        if ((fileFormat && fileFormat.value === 'audio') || (fileFormatUploader && fileFormatUploader.value === 'audio')) {
            let acceptAudio = []
            {
                audioFormatSelection.map((audioFormat, index) => {
                    acceptAudio.push(audioFormat.value)
                })
            }
            const acceptOnly = acceptAudio.length > 0 ? acceptAudio.join(',') : "audio/mpeg, audio/ogg, audio/wav"
            return (
                <FormGroup className={classNameCustom}>
                    {
                        label.show ? <Label>{translatedLabel}{field.properties.required || minLength ? <sup>*</sup> : ''}</Label> : ''
                    }
                    <Field
                        name={classProperty}
                        component={FileValidationMessage}
                        fileCountValidator={this.validateFileCount}
                        validate={validations}
                    />

                    <Dropzone multiple={field.collection} className={classNameCustomField} accept={acceptOnly} ref={(node) => { dropzoneRef = node; }} onDrop={this.onDrop.bind(this)}>
                        <div className='d-flex flex-column pt-2 pb-2 dropboxDiv'>
                            <p className='text-center'><i className="fa fa-3x fa-cloud-upload text-info" aria-hidden="true"></i></p>
                            <p className='text-center mb-1 mt-0'>Drag &amp; Drop Audio files here</p>
                            <p className='text-center mb-1 mt-0'>or</p>
                            <p className='text-center mb-0'>
                                <Button onClick={(ev) => { ev.preventDefault() }} color='success' outline>Choose File</Button>
                            </p>
                        </div>
                    </Dropzone>

                    <FilesList files={files} removeFile={this.removeFile.bind(this)} {...this.props} />
                    {!(files.length > 0) && uploadedFileName && !(uploadedFileName === "null") && !removedFile &&
                        <ViewFileOption
                            uploadedFileName={uploadedFileName}
                            uploadFileNameUrl={uploadFileNameUrl}
                            classProperty={classProperty}
                            removeFileFromForm={this.removeFileFromForm.bind(this)}
                        />
                        // <div>{
                        //     uploadedFileName.startsWith('protected/') ? <a href={""} onClick={(e) => {
                        //         e.preventDefault()
                        //         client().get(`${config.playerApi}/${uploadedFileName}`).then(res => {
                        //             window.open(res.data);
                        //         }).catch(e => {
                        //             console.log(e)
                        //         })

                        //     }}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download (${uploadedFileName})`}</a> : <a target="_blank" href={uploadFileNameUrl}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download (${uploadedFileName})`}</a>
                        // }
                        //     <Button onClick={this.removeFileFromForm.bind(this, classProperty)} color='link' className='p-0 ml-1' title='Remove this file'>
                        //         <i className="fa fa-times text-danger" aria-hidden="true"></i>
                        //     </Button></div>
                    }
                    {
                        footer && footer.show ? <h6 width='100%' className="footer-text">{footer.text}</h6> : ''
                    }
                </FormGroup>
            );

        }
        if ((fileFormat && fileFormat.value === 'video') || (fileFormatUploader && fileFormatUploader.value === 'video')) {
            let acceptVideo = []
            {
                videoFormatSelection.map((videoFormat, index) => {
                    acceptVideo.push(videoFormat.value)
                })
            }
            const acceptOnly = acceptVideo.length > 0 ? acceptVideo.join(',') : "video/avi, video/mp4 , video/ogg,video/x-ms-asf,video/webm"
            return (
                <FormGroup className={classNameCustom}>
                    {
                        label.show ? <Label>{translatedLabel}{field.properties.required || minLength ? <sup>*</sup> : ''}</Label> : ''
                    }
                    <Field
                        name={classProperty}
                        component={FileValidationMessage}
                        fileCountValidator={this.validateFileCount}
                        validate={validations}
                    />

                    <Dropzone multiple={field.collection} className={classNameCustomField} accept={acceptOnly} ref={(node) => { dropzoneRef = node; }} onDrop={this.onDrop.bind(this)}>
                        <div className='d-flex flex-column pt-2 pb-2 dropboxDiv'>
                            <p className='text-center'><i className="fa fa-3x fa-cloud-upload text-info" aria-hidden="true"></i></p>
                            <p className='text-center mb-1 mt-0'>Drag &amp; Drop Video files here</p>
                            <p className='text-center mb-1 mt-0'>or</p>
                            <p className='text-center mb-0'>
                                <Button onClick={(ev) => { ev.preventDefault() }} color='success' outline>Choose File</Button>
                            </p>
                        </div>
                    </Dropzone>

                    <FilesList files={files} removeFile={this.removeFile.bind(this)} {...this.props} />
                    {!(files.length > 0) && uploadedFileName && !(uploadedFileName === "null") && !removedFile && <div><a target="_blank" href={uploadFileNameUrl}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download (${uploadedFileName})`}</a>
                        <Button onClick={this.removeFileFromForm.bind(this, classProperty)} color='link' className='p-0 ml-1' title='Remove this file'>
                            <i className="fa fa-times text-danger" aria-hidden="true"></i>
                        </Button></div>}
                    {
                        footer && footer.show ? <h6 width='100%' className="footer-text">{footer.text}</h6> : ''
                    }
                </FormGroup>
            );

        }
        if ((fileFormat && fileFormat.value === 'file') || (fileFormatUploader && fileFormatUploader.value === 'file')) {
            let acceptFile = []
            {
                fileFormatSelection.map((fileFormat, index) => {
                    acceptFile.push(fileFormat.value)
                })
            }
            const acceptOnly = acceptFile.length > 0 ? acceptFile.join(',') : "application/doc, application/excel, application/mspowerpoint,application/pdf,application/json,.csv,.css"
            return (
                <FormGroup className={classNameCustom}>
                    {
                        label.show ? <Label>{translatedLabel}{field.properties.required || minLength ? <sup>*</sup> : ''}</Label> : ''
                    }


                    <Dropzone multiple={field.collection} className={classNameCustomField} accept={acceptOnly} ref={(node) => { dropzoneRef = node; }} onDrop={this.onDrop.bind(this)}>
                        <div className='d-flex flex-column pt-2 pb-2 dropboxDiv'>
                            <p className='text-center'><i className="fa fa-3x fa-cloud-upload text-info" aria-hidden="true"></i></p>
                            <p className='text-center mb-1 mt-0'>{dropboxMainText}</p>
                            <p className='text-center mb-1 mt-0'>or</p>
                            <p className='text-center mb-0'>
                                <Button onClick={(ev) => { ev.preventDefault() }} color='success' outline>Choose File</Button>
                            </p>
                        </div>
                    </Dropzone>
                    <Field
                        name={classProperty}
                        component={FileValidationMessage}
                        fileCountValidator={this.validateFileCount}
                        validate={validations}
                    />

                    <FilesList files={files} removeFile={this.removeFile.bind(this)} {...this.props} />
                    {!(files.length > 0) && uploadedFileName && !(uploadedFileName === "null") && !removedFile &&
                        <ViewFileOption
                            uploadedFileName={uploadedFileName}
                            uploadFileNameUrl={uploadFileNameUrl}
                            classProperty={classProperty}
                            removeFileFromForm={this.removeFileFromForm.bind(this)}
                        />
                        // <div>{
                        //     uploadedFileName.startsWith('protected/') ? <a href={""} onClick={(e) => {
                        //         e.preventDefault()
                        //         client().get(`${config.playerApi}/${uploadedFileName}`).then(res => {
                        //             console.log(res);
                        //             window.open(res.data);
                        //         }).catch(e => {
                        //             console.log(e)
                        //         })

                        //     }}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download (${uploadedFileName})`}</a> : <a target="_blank" href={uploadFileNameUrl}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download (${uploadedFileName})`}</a>
                        // }
                        //     <Button onClick={this.removeFileFromForm.bind(this, classProperty)} color='link' className='p-0 ml-1' title='Remove this file'>
                        //         <i className="fa fa-times text-danger" aria-hidden="true"></i>
                        //     </Button></div>
                    }
                    {
                        footer && footer.show ? <h6 width='100%' className="footer-text">{footer.text}</h6> : ''
                    }
                </FormGroup>
            );

        }
        if ((fileFormatUploader && fileFormatUploader.value === 'all')) {
            let acceptFile = []
            {
                allFormatSelection.map((fileFormat, index) => {
                    acceptFile.push(fileFormat.value)
                })
            }
            const acceptOnly = acceptFile.length > 0 ? acceptFile.join(',') : "application/doc, application/excel, application/mspowerpoint,application/pdf,application/json,.csv,.css"
            return (
                <FormGroup className={!dontShowDROPBOX ? `${classNameCustom}` : 'player-dropzone-uploader-wrapper create-update-table-dropbox'} >
                    {
                        label.show ? <Label>{translatedLabel}{field.properties.required || minLength ? <sup>*</sup> : ''}</Label> : ''
                    }

                    {!(onlyIconDropboxImage || onlyIconDropboxFile || onlyIconDropboxVideoFile) ? <Dropzone multiple={field.collection} className={classNameCustomField} accept={acceptOnly} ref={(node) => { dropzoneRef = node; }} onDrop={this.onDrop.bind(this)}>
                        <div className='d-flex flex-column pt-2 pb-2 dropboxDiv'>
                            <p className='text-center'><i className="fa fa-3x fa-cloud-upload text-info" aria-hidden="true"></i></p>
                            <p className='text-center mb-1 mt-0'>{dropboxMainText}</p>
                            <p className='text-center mb-1 mt-0'>or</p>
                            <p className='text-center mb-0'>
                                <Button onClick={(ev) => { ev.preventDefault() }} color='success' outline>Choose File</Button>
                            </p>
                        </div>
                    </Dropzone> :
                        <Dropzone multiple={field.collection} className={!dontShowDROPBOX ? 'player-dropzone-uploader-only-icon-wrapper ' : 'player-dropzone-uploader-only-icon-wrapper create-update-table-icon-wrapper'} accept={acceptOnly} ref={(node) => { dropzoneRef = node; }} onDrop={this.onDrop.bind(this)}>{itemProperties.beforeIcon ? <RenderIcon className="player-dropzone-uploader-only-icon" config={itemProperties.beforeIcon} customIcons={customIcons} color={itemProperties.textColor ? itemProperties.textColor.value : ''} /> : dontShowDROPBOX ? <i className="fa fa-upload" style={{ fontSize: 18 }} aria-hidden="true"></i> : null}</Dropzone>}
                    {!dontShowDROPBOX && <Field
                        name={classProperty}
                        component={FileValidationMessage}
                        fileCountValidator={this.validateFileCount}
                        validate={validations}
                    />}


                    <FilesList files={files} removeFile={this.removeFile.bind(this)} {...this.props} />
                    {!(files.length > 0) && uploadedFileName && !(uploadedFileName === "null") && !dontShowDROPBOX && !removedFile &&
                        <ViewFileOption
                            uploadedFileName={uploadedFileName}
                            uploadFileNameUrl={uploadFileNameUrl}
                            classProperty={classProperty}
                            removeFileFromForm={this.removeFileFromForm.bind(this)}
                        />
                        // <div><a target="_blank" href={uploadFileNameUrl}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download (${uploadedFileName})`}</a>
                        //     <Button onClick={this.removeFileFromForm.bind(this, classProperty)} color='link' className='p-0 ml-1' title='Remove this file'>
                        //         <i className="fa fa-times text-danger" aria-hidden="true"></i>
                        //     </Button></div>
                    }
                    {!(files.length > 0) && uploadedFileName && !(uploadedFileName === "null") && dontShowDROPBOX && !removedFile &&
                        <ViewFileOption
                            uploadedFileName={uploadedFileName}
                            uploadFileNameUrl={uploadFileNameUrl}
                            classProperty={classProperty}
                            removeFileFromForm={this.removeFileFromForm.bind(this)}
                            dontShowDROPBOX={dontShowDROPBOX} />
                        // <div><a target="_blank" href={uploadFileNameUrl}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download`}</a>
                        //     <Button onClick={this.removeFileFromForm.bind(this, classProperty)} color='link' className='p-0 ml-1' title='Remove this file'>
                        //         <i className="fa fa-times text-danger" aria-hidden="true"></i>
                        //     </Button></div>
                    }

                    {
                        footer && footer.show ? <h6 width='100%' className="footer-text">{footer.text}</h6> : ''
                    }
                    {dontShowDROPBOX && <Field
                        name={classProperty}
                        component={FileValidationMessage}
                        fileCountValidator={this.validateFileCount}
                        validate={validations}
                    />}

                </FormGroup>
            );

        }
        if ((fileboxtemplate && fileboxtemplate.value === 'template3') || (fileboxtemplateImage && fileboxtemplateImage.value === 'template3')) {
            return <FormGroup className={!dontShowDROPBOX ? 'player-dropzone-uploader-wrapper-template3' : 'player-dropzone-uploader-wrapper create-update-table-dropbox-template3'} >
                {
                    label.show ? <Label>{translatedLabel}{field.properties.required || minLength ? <sup>*</sup> : ''}
                        {info && info.show && info.text && <> <i className="fa fa-info-circle ml-3 info-icon-Li" aria-hidden="true" id={`li_${fieldID}`}></i>
                            <UncontrolledTooltip delay={100} className={'infoToolTip'} placement='right' target={`li_${fieldID}`}>
                                {info.text}
                            </UncontrolledTooltip>
                        </>
                        }

                    </Label> : ''
                }

                {!(onlyIconDropboxImage || onlyIconDropboxFile || onlyIconDropboxVideoFile) ? <Dropzone multiple={field.collection} className='player-dropzone-uploader-template3' accepts="application/msword, application/pdf" ref={(node) => { dropzoneRef = node; }} onDrop={this.onDrop.bind(this)}>
                    <div className='d-flex flex-row pt-2 pb-2 intoBox-template3'>

                        <p className=' draganddrop'>{dropboxMainText} |     <p className='filesize-player-template3'> Max Size : 10mb</p></p>

                        <p className='text-center'><i className="fa fa-2x fa-upload text-info" aria-hidden="true"></i></p>

                    </div>
                </Dropzone> :
                    <Dropzone multiple={field.collection} className={!dontShowDROPBOX ? 'player-dropzone-uploader-only-icon-wrapper ' : 'player-dropzone-uploader-only-icon-wrapper create-update-table-icon-wrapper'} accepts="application/msword, application/pdf" ref={(node) => { dropzoneRef = node; }} onDrop={this.onDrop.bind(this)}>{itemProperties.beforeIcon ? <RenderIcon className="player-dropzone-uploader-only-icon" config={itemProperties.beforeIcon} customIcons={customIcons} color={itemProperties.textColor ? itemProperties.textColor.value : ''} /> : dontShowDROPBOX ? <i className="fa fa-upload" style={{ fontSize: 18 }} aria-hidden="true"></i> : null}</Dropzone>}
                <Field
                    name={classProperty}
                    component={FileValidationMessage}
                    fileCountValidator={this.validateFileCount}
                    validate={validations}
                />
                <FilesList files={files} removeFile={this.removeFile.bind(this)} {...this.props} />
                {!(files.length > 0) && uploadedFileName && !(uploadedFileName === "null") && !dontShowDROPBOX && !removedFile && <div><a target="_blank" href={uploadFileNameUrl}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download (${uploadedFileName})`}</a>
                    <Button onClick={this.removeFileFromForm.bind(this, classProperty)} color='link' className='p-0 ml-1' title='Remove this file'>
                        <i className="fa fa-times text-danger" aria-hidden="true"></i>
                    </Button></div>
                }
                {!(files.length > 0) && uploadedFileName && !(uploadedFileName === "null") && dontShowDROPBOX && !removedFile && <div><a target="_blank" href={uploadFileNameUrl}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download`}</a>
                    <Button onClick={this.removeFileFromForm.bind(this, classProperty)} color='link' className='p-0 ml-1' title='Remove this file'>
                        <i className="fa fa-times text-danger" aria-hidden="true"></i>
                    </Button></div>
                }

                {
                    footer && footer.show ? <h6 width='100%' className="footer-text">{footer.text}</h6> : ''
                }
            </FormGroup>
        }
        if ((fileboxtemplate && fileboxtemplate.value === 'template2') || (fileboxtemplateImage && fileboxtemplateImage.value === 'template2')) {
            return <FormGroup className={!dontShowDROPBOX ? 'player-dropzone-uploader-wrapper newStyleDropbox' : 'player-dropzone-uploader-wrapper create-update-table-dropbox'} >
                <Row>
                    <Col sm={5}>
                        {
                            label.show ? <Label>{translatedLabel}{field.properties.required || minLength ? <sup>*</sup> : ''}
                                {info && info.show && info.text && <> <i className="fa fa-info-circle ml-3 info-icon-Li" aria-hidden="true" id={`li_${fieldID}`}></i>
                                    <UncontrolledTooltip delay={100} className={'infoToolTip'} placement='right' target={`li_${fieldID}`}>
                                        {info.text}
                                    </UncontrolledTooltip>
                                </>
                                }

                            </Label> : ''
                        }


                    </Col>
                    <Col sm={3}>
                        {!(files && files.length > 0) ? <div><i className="fa fa-circle" style={{ color: 'red' }} aria-hidden="true"></i> Pending</div> : <div><i className="fa fa-check-circle" style={{ color: 'green' }} aria-hidden="true"></i> Uploaded</div>}
                    </Col>
                    <Col sm={4}>
                        {!(onlyIconDropboxImage || onlyIconDropboxFile || onlyIconDropboxVideoFile) ? <Dropzone multiple={field.collection} className={classNameCustomField} accepts="application/msword, application/pdf" ref={(node) => { dropzoneRef = node; }} onDrop={this.onDrop.bind(this)}>
                            <div className='d-flex flex-column pt-2 pb-2 dropboxDiv'>
                                <p className='text-center mb-1 mt-0'>{dropboxMainText}</p>
                            </div>
                        </Dropzone> :
                            <Dropzone multiple={field.collection} className={!dontShowDROPBOX ? 'player-dropzone-uploader-only-icon-wrapper ' : 'player-dropzone-uploader-only-icon-wrapper create-update-table-icon-wrapper'} accepts="application/msword, application/pdf" ref={(node) => { dropzoneRef = node; }} onDrop={this.onDrop.bind(this)}>{itemProperties.beforeIcon ? <RenderIcon className="player-dropzone-uploader-only-icon" config={itemProperties.beforeIcon} customIcons={customIcons} color={itemProperties.textColor ? itemProperties.textColor.value : ''} /> : dontShowDROPBOX ? <i className="fa fa-upload" style={{ fontSize: 18 }} aria-hidden="true"></i> : null}</Dropzone>}
                        <Field
                            name={classProperty}
                            component={FileValidationMessage}
                            fileCountValidator={this.validateFileCount}
                            validate={validations}
                        />
                        <FilesList files={files} removeFile={this.removeFile.bind(this)} {...this.props} />
                        {!(files.length > 0) && uploadedFileName && !(uploadedFileName === "null") && !dontShowDROPBOX && !removedFile && <div><a target="_blank" href={uploadFileNameUrl}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download (${uploadedFileName})`}</a>
                            <Button onClick={this.removeFileFromForm.bind(this, classProperty)} color='link' className='p-0 ml-1' title='Remove this file'>
                                <i className="fa fa-times text-danger" aria-hidden="true"></i>
                            </Button></div>
                        }
                        {!(files.length > 0) && uploadedFileName && !(uploadedFileName === "null") && dontShowDROPBOX && !removedFile && <div><a target="_blank" href={uploadFileNameUrl}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download`}</a>
                            <Button onClick={this.removeFileFromForm.bind(this, classProperty)} color='link' className='p-0 ml-1' title='Remove this file'>
                                <i className="fa fa-times text-danger" aria-hidden="true"></i>
                            </Button></div>
                        }
                    </Col>
                </Row>

                {
                    footer && footer.show ? <h6 width='100%' className="footer-text">{footer.text}</h6> : ''
                }
            </FormGroup>
        }
        return (
            <FormGroup className={!dontShowDROPBOX ? `${classNameCustom}` : 'player-dropzone-uploader-wrapper create-update-table-dropbox'} >
                {
                    label.show ? <Label>{translatedLabel}{field.properties.required || minLength ? <sup>*</sup> : ''}
                        {info && info.show && info.text && <> <i className="fa fa-info-circle ml-3 info-icon-Li" aria-hidden="true" id={`li_${fieldID}`}></i>
                            <UncontrolledTooltip delay={100} className={'infoToolTip'} placement='right' target={`li_${fieldID}`}>
                                {info.text}
                            </UncontrolledTooltip>
                        </>
                        }

                    </Label> : ''
                }

                {!(onlyIconDropboxImage || onlyIconDropboxFile || onlyIconDropboxVideoFile) ? <Dropzone multiple={field.collection} className={classNameCustomField} accepts="application/msword, application/pdf" ref={(node) => { dropzoneRef = node; }} onDrop={this.onDrop.bind(this)}>
                    <div className='d-flex flex-column pt-2 pb-2 dropboxDiv'>
                        <p className='text-center'><i className="fa fa-3x fa-cloud-upload text-info" aria-hidden="true"></i></p>
                        <p className='text-center mb-1 mt-0'>{dropboxMainText}</p>
                        <p className='text-center mb-1 mt-0'>or</p>
                        <p className='text-center mb-0'>
                            <Button onClick={(ev) => { ev.preventDefault() }} color='success' outline>Choose File</Button>
                        </p>
                    </div>
                </Dropzone> :
                    <Dropzone multiple={field.collection} className={!dontShowDROPBOX ? 'player-dropzone-uploader-only-icon-wrapper ' : 'player-dropzone-uploader-only-icon-wrapper create-update-table-icon-wrapper'} accepts="application/msword, application/pdf" ref={(node) => { dropzoneRef = node; }} onDrop={this.onDrop.bind(this)}>{itemProperties.beforeIcon ? <RenderIcon className="player-dropzone-uploader-only-icon" config={itemProperties.beforeIcon} customIcons={customIcons} color={itemProperties.textColor ? itemProperties.textColor.value : ''} /> : dontShowDROPBOX ? <i className="fa fa-upload" style={{ fontSize: 18 }} aria-hidden="true"></i> : null}</Dropzone>}
                <Field
                    name={classProperty}
                    component={FileValidationMessage}
                    fileCountValidator={this.validateFileCount}
                    validate={validations}
                />
                <FilesList files={files} removeFile={this.removeFile.bind(this)} {...this.props} />
                {!(files.length > 0) && uploadedFileName && !(uploadedFileName === "null") && !dontShowDROPBOX && !removedFile &&
                    <ViewFileOption
                        uploadedFileName={uploadedFileName}
                        uploadFileNameUrl={uploadFileNameUrl}
                        classProperty={classProperty}
                        removeFileFromForm={this.removeFileFromForm.bind(this)} />
                }
                {!(files.length > 0) && uploadedFileName && !(uploadedFileName === "null") && dontShowDROPBOX && !removedFile &&
                    <ViewFileOption
                        uploadedFileName={uploadedFileName}
                        uploadFileNameUrl={uploadFileNameUrl}
                        classProperty={classProperty}
                        removeFileFromForm={this.removeFileFromForm.bind(this)}
                        dontShowDROPBOX={dontShowDROPBOX} />
                    // <div ><a target="_blank" href={uploadFileNameUrl}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{`View/Download`}</a>
                    //     <Button onClick={this.removeFileFromForm.bind(this, classProperty)} color='link' className='p-0 ml-1' title='Remove this file'>
                    //         <i className="fa fa-times text-danger" aria-hidden="true"></i>
                    //     </Button></div>
                }

                {
                    footer && footer.show ? <h6 width='100%' className="footer-text">{footer.text}</h6> : ''
                }
            </FormGroup>
        );
    }
}

const ViewFileOption = (props) => {
    const { uploadedFileName, uploadFileNameUrl, classProperty, removeFileFromForm, dontShowDROPBOX } = props;
    return <div>
        {
            Array.isArray(uploadedFileName) ? uploadedFileName.map((name, i) => {
                return <div>{name.startsWith('protected/') ? <a href={""} onClick={(e) => {
                    e.preventDefault();
                    openProtectedFile(name)

                }}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{dontShowDROPBOX ? `View/Download` : `View/Download (${name})`}</a> :
                    <a target="_blank" href={uploadFileNameUrl[i]}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{dontShowDROPBOX ? `View/Download` : `View/Download (${name})`}</a>
                }<Button onClick={() => { removeFileFromForm(classProperty, i) }} color='link' className='p-0 ml-1 ' title='Remove this file'>
                        <i className="fa fa-times text-danger" aria-hidden="true"></i>
                    </Button></div>
            }) : <div>
                {
                    uploadedFileName.startsWith('protected/') ? <a href={""} onClick={(e) => {
                        e.preventDefault();
                        openProtectedFile(uploadedFileName)

                    }}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{dontShowDROPBOX ? `View/Download` : `View/Download (${uploadedFileName})`}</a> :
                        <a target="_blank" href={uploadFileNameUrl}><i className="fa fa-external-link mr-1" aria-hidden="true"></i>{dontShowDROPBOX ? `View/Download` : `View/Download (${uploadedFileName})`}</a>
                }
                <Button onClick={() => { removeFileFromForm(classProperty) }} color='link' className='p-0 ml-1 ' title='Remove this file'>
                    <i className="fa fa-times text-danger" aria-hidden="true"></i>
                </Button>
            </div>
        }
    </div>
}

const openProtectedFile = (uploadedFileName) => {
    const newUploadedFileName = uploadedFileName
        .replace(/\/+/g, "/")
        // .replace("/protected/protected", "/protected");

    console.log(newUploadedFileName);
      client().get(`${config.playerApi}/${newUploadedFileName}`).then(res => {
        window.open(res.data);
    }).catch(e => {
        console.log(e)
    })
}

const formatFileSize = (bytes, decimalPoint) => {
    if (bytes == 0) return '0 Bytes';
    var k = 1000,
        dm = decimalPoint || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const FilesList = (props) => {
    const { files, removeFile, classProperty } = props;
    return (
        <div className='mt-2'>
            {
                files.map((file, index) => {
                    return <div key={index} className='file-info d-flex justify-content-between'>
                        <div>
                            {/*<a href={file.preview} target='_blank' className='mb-0'>
                                {file.name} ({formatFileSize(file.size)}){' '}
                                <i className="fa fa-external-link ml-1 text-muted" aria-hidden="true"></i>
						</a>*/}
                            {file.name} ({formatFileSize(file.size)}){' '}
                        </div>
                        <div>
                            <Button onClick={removeFile.bind(this, index, classProperty)} color='link' className='p-0' title='Remove this file'>
                                <i className="fa fa-times text-danger" aria-hidden="true"></i>
                            </Button>
                        </div>
                    </div>
                })
            }
        </div>

    )
}

const mapStateToProps = (state, ownProps) => {
    const form = ownProps.inlineFormKey && ownProps.inlineFormKey.startsWith('workflow-card')
        ? 'create-update-form-base' : ownProps.form || 'create-update-form-base';
    const fileValue = formValueSelector(form)(state, ownProps.classProperty)
    return {
        uploader: state.getIn(['uploader', `uploader_for_${ownProps.classProperty}`]),
        fileValue
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        uploadFiles: (payload) => {
            dispatch(uploadFiles(payload));
        },
        clearUploader: (namespace) => {
            dispatch(clearUploader(namespace));
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(toJS(Uploader));
